import { render, staticRenderFns } from "./RateChange.vue?vue&type=template&id=52637fdf"
import script from "./RateChange.vue?vue&type=script&lang=js"
export * from "./RateChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports